import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
    {
        path: 'datos-basicos',
        loadChildren: () => import('./main/datos-basicos/datos-basicos.module').then(m => m.DatosBasicosModule)
    },

    {
        path: 'pasivos-exigibles',
        loadChildren: () => import('./main/pasivos-exigibles/pasivos-exigibles.module').then(m => m.PasivosExigiblesModule)
    },

    {
        path      : '**',
        redirectTo: 'home'
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
